// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Client model hasMany relations 1`] = `
Array [
  "Entity",
  "GLCode",
]
`;
